import { graphQlRequest } from '@ria-client/supergraph/graphql-client/utils';
import { MarketplaceStatusEnum, MonetizableEnum } from '@ria-client/supergraph/marketplace/enums';
import { ctaSchema, entityTypeSchema } from '@ria-client/supergraph/marketplace/schema';
import { nulltoOptional } from '@ria-client/supergraph/utils/validation-utils';
import * as v from 'valibot';

const marketplaceEntitySchema = v.object({
  id: v.string(),
  name: v.string(),
  entityType: nulltoOptional(entityTypeSchema),
  productType: v.string(),
  monetizable: v.enum(MonetizableEnum),
  cta: nulltoOptional(ctaSchema),
  status: v.enum(MarketplaceStatusEnum),
  product: v.object({
    id: v.string(),
    name: nulltoOptional(v.string()),
    institution: v.object({
      id: v.string(),
      name: nulltoOptional(v.string()),
      displayName: nulltoOptional(v.string()),
    }),
  }),
  reviewLink: nulltoOptional(v.pipe(v.string(), v.url())),
});

type MarketplaceEntity = v.InferOutput<typeof marketplaceEntitySchema>;

export async function getSmbMarketplaceEntity(id: string): Promise<MarketplaceEntity | null> {
  try {
    const response = await graphQlRequest<{ marketplaceEntityV2: MarketplaceEntity }>(
      QUERY_ENTITY,
      { id },
    );
    return response?.marketplaceEntityV2
      ? v.parse(marketplaceEntitySchema, response.marketplaceEntityV2)
      : null;
  } catch {
    return null;
  }
}

const QUERY_ENTITY = `
  query SMBIllustrationCardListMarketplaceEntity($id: ID!) {
    marketplaceEntityV2(id: $id) {
      __typename
      id
      status
      name
      productType
      entityType
      ... on BankingOfferV2 {
        monetizable
        cta { text subtext link type }
        product { id name institution { id displayName } }
        reviewLink
      }
      ... on InvestingOfferV2 {
        monetizable
        cta { text subtext link type }
        product { id name institution { id name } }
        reviewLink
      }
    }
  }
`;
